<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { useAuthStore } from '@/stores/useAuthStore'

const { t } = useI18n()
const { umsokn } = useUmsokn() // ref
const auth = useAuthStore()

const props = defineProps<{
  disable?: boolean
  handleNext?: () => void
  handlePrev?: () => void
}>()


// --- Validation (checkboxes must be checked) ---
const rules = {
  umsokn: {
    confirmLowerRights: { sameAs: sameAs(true) },
    confirmContinueWithApplication: { sameAs: sameAs(true) },
  },
}

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  },
})
</script>

<template>
  <div v-if="umsokn">
    <v-row>
      <v-col>
        <h2 class="form__header">
          {{ t('umsokn_tilgreind_sereign_step4_1_header') }}
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="step4-content">
        <strong>
          {{ t('umsokn_tilgreind_sereign_step4_1_text') }}
        </strong>

        <ul class="list-with-dots m-t-10">
          <li>{{ t('umsokn_tilgreind_sereign_step4_1_text_1') }}</li>
          <li>{{ t('umsokn_tilgreind_sereign_step4_1_text_2') }}</li>
          <li>{{ t('umsokn_tilgreind_sereign_step4_1_text_3') }}</li>
          <li>{{ t('umsokn_tilgreind_sereign_step4_1_text_4') }}</li>
        </ul>

        <p>{{ t('umsokn_tilgreind_sereign_step4_1_text_5') }}</p>

        <ul class="list-with-dots">
          <li>{{ t('umsokn_tilgreind_sereign_step4_1_text_6') }}</li>
          <li>{{ t('umsokn_tilgreind_sereign_step4_1_text_7') }}</li>
          <li>{{ t('umsokn_tilgreind_sereign_step4_1_text_8') }}</li>
          <li>{{ t('umsokn_tilgreind_sereign_step4_1_text_9') }}</li>
        </ul>
        </div>

        <!-- <p>{{ t('umsokn_tilgreind_sereign_step4_1_text_10') }}</p> -->
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-checkbox
          v-model="umsokn.confirmLowerRights"
          :label="t('umsokn_tilgreind_sereign_step4_confirmLower')"
          :readonly="props.disable"
          density="comfortable"
          :error="v$.umsokn.confirmLowerRights.$error"
          :error-messages="
            v$.umsokn.confirmLowerRights.$error
              ? [t('umsokn_tilgreind_sereign_step4_confirm_error')]
              : []
          "
        />

        <div class="m-t-10">
          <v-checkbox
            v-model="umsokn.confirmContinueWithApplication"
            :label="t('umsokn_tilgreind_sereign_step4_confirmContinue')"
            :readonly="props.disable"
            density="comfortable"
            :error="v$.umsokn.confirmContinueWithApplication.$error"
            :error-messages="
              v$.umsokn.confirmContinueWithApplication.$error
                ? [t('umsokn_tilgreind_sereign_step4_confirm_error')]
                : []
            "
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<style lang="scss" scoped>
.step4-content {
  padding: 16px 24px 0;
}

.step4-content :deep(.list-with-dots) {
  padding-left: 40px !important;
  margin-top: 10px;
  margin-bottom: 10px;
}

.step4-content :deep(.list-with-dots li) {
  font-size: 18px;
  color: #505050;
}

.step4-content p {
  margin-top: 16px;
  margin-bottom: 4px;
}
</style>
